(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('userwise-turnover-report', {
            parent: 'entity',
            url: '/userwise-turnover-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userwiseTurnoverReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/userwise-turnover-report/userwise-turnover-report.html',
                    controller: 'UserwiseTurnoverReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	userRoleList: ['OrderStatusDetails', function(OrderStatusDetails) {
                    return OrderStatusDetails.getUserRoleListFromUser().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderStatusReport');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('userwiseTurnoverReport');
                    return $translate.refresh();
                }]
               
            }
        })
        
        
        
         
         };
    })();
